import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'mt-multi-select',
    templateUrl: './multi-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiSelectComponent implements OnInit, OnChanges {
  @ViewChild('searchInput') searchInput: ElementRef | null = null;
  @ViewChild('auto') matAutocomplete: MatAutocomplete | null = null;
  @Input() placeholder: string = "";
  @Input() label?: string;
  @Input() options?: any;
  @Input() type?: string = 'text';
  @Input() required: boolean = false;
  @Input() class?: string;
  @Input() inputValuesArr: any = [];
  @Input() inputDisplayArr: any = [];
  @Input() disabled?: boolean = false;
  @Input() value?: any;
  @Input() display?: string;
  @Input() loading?: boolean = false;
  @Input() noDataFound: boolean = false;
  @Output() searchStart = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();

  autocompleteControl = new FormControl();
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  filteredOptions: any = [];
  searchedOption: any = [];
  selectedArr: any = [];
  search = '';

  constructor(private sb: MatSnackBar) {}

  ngOnInit() {
    this.autocompleteControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(search => {
        this.searchStart.emit(search);
      });
  }

  ngOnChanges() {
    if (this.inputValuesArr && this.inputValuesArr.length > 0) {
      this.selectedArr = [...this.inputValuesArr];
    }

    if (this.inputDisplayArr && this.inputDisplayArr.length > 0) {
      this.searchedOption = [...this.inputDisplayArr];
    }

    this.disabled && !this.autocompleteControl.disabled
      ? this.autocompleteControl.disable()
      : !this.disabled && this.autocompleteControl.disabled
      ? this.autocompleteControl.enable()
      : null;
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete!.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        this.searchedOption.push(value.trim());
      }

      if (input) {
        input.value = '';
      }

      this.search = '';
    }
  }

  remove(i: string): void {
    const index = this.searchedOption.indexOf(i);
    if (index >= 0) {
      this.searchedOption.splice(index, 1);
      this.selectedArr.splice(index, 1);
      this.onChange.emit({ displayArr: this.searchedOption, valuesArr: this.selectedArr, remove: true });
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedArr.includes(event.option.value)) {
      this.sb.open(`Yo've already seleted ${event.option.viewValue}`, 'cancel', {
        duration: 2000,
        panelClass: ['warning']
      });
      return;
    }
    this.searchedOption.push(event.option.viewValue);
    this.selectedArr.push(this.value ? event.option.value : event.option.viewValue);
    this.onChange.emit({ displayArr: this.searchedOption, valuesArr: this.selectedArr, add: true });
    this.searchInput!.nativeElement.value = '';
    this.search = '';
    return;
  }
}